// extracted by mini-css-extract-plugin
export var blue = "_3t-h";
export var brand = "_3t-d";
export var darkGrey = "_3t-g";
export var disabled = "_3t-6";
export var disabledSubtle = "_3t-7";
export var error = "_3t-8";
export var green = "_3t-i";
export var grey = "_3t-f";
export var icon = "_3t-0";
export var inherit = "_3t-c";
export var lightGrey = "_3t-e";
export var orange = "_3t-k";
export var pink = "_3t-m";
export var primary = "_3t-1";
export var purple = "_3t-n";
export var quaternary = "_3t-4";
export var quinary = "_3t-5";
export var red = "_3t-l";
export var secondary = "_3t-2";
export var success = "_3t-b";
export var tertiary = "_3t-3";
export var warning = "_3t-9";
export var warningSecondary = "_3t-a";
export var white = "_3t-o";
export var yellow = "_3t-j";